const emptySiteInfo = () => {
    return {
        ownerNameShort: '',
        ownerNameLegal: '',
        website: '',
        email: '',
        phone: '',
        orgNo: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        siteLocation: {
            gps: '',
            addressLine1: '',
            addressLine2: '',
            addressLine3: ''
        }
    };
};
const toSiteInfo = (raw) => {
    if (!raw)
        return emptySiteInfo();
    const startingPoint = emptySiteInfo();
    Object.assign(startingPoint, raw);
    return startingPoint;
};
export { emptySiteInfo, toSiteInfo };
//# sourceMappingURL=siteInfo.js.map